module.exports = __webpack_public_path__ + "fonts/dxicons.1286a19.woff2";